import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import bank from "../.././../images/bnk.png";
import accountNumber from "../.././../images/accountNumber.png";
import nachAmount from "../.././../images/nachAmount.png";
import customBank from "../.././../images/customBank.png";
import remark from "../.././../images/remark.png";
import mandateEndDate from "../.././../images/mandateEndDate.png";
import fnbd from "../.././../images/fnbd.png";
import accHolderName from "../.././../images/accHolderName.png";
import mandateStartDate from "../.././../images/mandateStartDate.png";
import fbd from "../.././../images/fbd.png";
import debitType from "../.././../images/debitType.png";
import mobile from "../.././../images/mobile.png";
import email from "../.././../images/email.png";
import ifsc from "../.././../images/ifsc.png";
import approve from "../.././../images/approve.png";
import frequency from "../.././../images/frequency.png";
import Person from "../.././../images/Person.png";
import mandateNumbers from "../.././../images/mandateNumber.png";
import mandateAmount from "../.././../images/mandateAmount.png";
import CustomCard from "../../CustomComponents/CustomCard";
import CustomTextField from "../../CustomComponents/CustomTextField";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import reject from "../.././../images/reject.png";
import CustomAutoComplete from "../../CustomComponents/CustomAutoComplete";

const NachDetails = () => {
  const filterScreen = useSelector((state) => state.cov.filterScreen);

  const [mandateNumberList, setMandateNumberList] = useState([]);
  const [mandateNumber, setMandateNumber] = useState(null);
  const [responseDataList, setResponseDataList] = useState();
  const [activeRecord, setActiveRecord] = useState();
  const [bankDetails, setBankDetails] = useState();
  const [losCustomerData, setLosCustomerData] = useState();
  const mandateNumberOnchangeHandler = (value) => {
    setMandateNumber(value);
    for (let key in responseDataList) {
      if (key === value) {
        setActiveRecord(responseDataList[key].nach);
        setBankDetails(responseDataList[key].customerDepandantBankDetails);
      }
    }
  };
  useEffect(() => {
    const appNum = localStorage.getItem("appNum");
    getNachData(appNum);
  }, []);

  const getNachData = async (appNum) => {
    const response = await axios.post("customerOneView/getNachDetailData", {
      applicationNum: appNum,
    });
    setLosCustomerData(response.data.losCustomer);
    setMandateNumberList(response.data.mandateNum);
    setResponseDataList(response.data.mandateMap);

    setActiveRecord(
      response.data.mandateMap[response.data?.mandateNum[0]].nach
    );
    setBankDetails(
      response.data.mandateMap[response.data?.mandateNum[0]]
        .customerDepandantBankDetails
    );
    setMandateNumber(response.data?.mandateNum[0]);
  };
  return (
    <>
      <Box sx={{ marginBottom: "8px" }}>
        <Grid container rowSpacing={2} columnSpacing={3}>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <CustomAutoComplete
              variant="standard"
              type="text"
              placeholder="Select Mandate Number"
              label="Select Mandate Number"
              disabled={mandateNumberList.length < 2}
              autoCompleteValues={mandateNumberList}
              value={mandateNumber}
              onChange={(e, value) => {
                mandateNumberOnchangeHandler(value);
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ padding: "8px", marginRight: "20px" }}>
        <Grid container rowSpacing={2} columnSpacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={bank}
              label="NACH Sponser Bank"
              value={activeRecord?.sponsorBank}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={accountNumber}
              label="Account Number"
              value={activeRecord?.bankAccountNum}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={Person}
              label="Application Number"
              value={activeRecord?.applicationNum}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={mandateAmount}
              label="Mandate Amount"
              value={activeRecord?.mandateAmt.toLocaleString("en-US")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={nachAmount}
              label="Nach Amount"
              value={activeRecord?.nachAmt.toLocaleString("en-US")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={frequency}
              label="Frequency"
              value={activeRecord?.frequency}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={debitType}
              label="Debit Type"
              value={activeRecord?.debitType}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={customBank}
              label="Customer Bank"
              value={activeRecord?.bankName}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={ifsc}
              label="IFSC"
              value={bankDetails?.ifscCode}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={accHolderName}
              label="Account Holder Name"
              value={activeRecord?.customerName}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={mandateStartDate}
              label="Mandate Start Date"
              value={new Date(
                activeRecord?.mandateStartDate
              ).toLocaleDateString("fr-FR")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={fbd}
              label="FBD"
              value={new Date(activeRecord?.fbd).toLocaleDateString("fr-FR")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={fnbd}
              label="NACH Billing Date"
              value={new Date(
                activeRecord?.firstNachBillingDate
              ).toLocaleDateString("fr-FR")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={mandateEndDate}
              label="Mandate End Date"
              value={new Date(activeRecord?.mandateEndDate).toLocaleDateString(
                "fr-FR"
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={mobile}
              label="Mobile Number"
              value={losCustomerData?.mobileNumber}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={email}
              label="Email"
              value={losCustomerData?.emailId}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={ifsc}
              label="Mandate Validity"
              value={activeRecord?.mandateValidity}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
            <CustomCard
              imgSrc={activeRecord?.status === "DEACTIVATED" ? reject : approve}
              label="Status"
              value={activeRecord?.status}
            />
          </Grid>
          {activeRecord?.status === "DEACTIVATED" && (
            <>
              <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                <CustomCard
                  imgSrc={mandateEndDate}
                  label="Deactivation Date"
                  value={new Date(
                    activeRecord?.deActivationDate
                  ).toLocaleDateString("fr-FR")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                <CustomCard
                  imgSrc={remark}
                  label="Remarks"
                  value={activeRecord?.rejectionRemarks}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </>
  );
};
export default NachDetails;
